import styled, { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';
import { mediaMinWidth } from 'themes/mixins/mediaQueries';

export type StyledFooterProps = {
  withMarginTop?: boolean;
};

type ContainerProps = {
  asSecondary?: boolean;
};

const Footer = styled.footer<StyledFooterProps>`
  justify-content: flex-end;

  width: 100%;
  height: 14.5rem;
  margin-top: auto;
  padding: 0 2rem;

  font-family: 'LFT Zeno Condensed', sans-serif;
  font-size: 1.4rem;

  background-color: ${pickColor('black')};
  color: ${pickColor('title')};

  ${mediaMinWidth.lg(css`
    height: 100%;
    padding: 4rem;
  `)}
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;

  ${mediaMinWidth.lg(css`
    flex-direction: column;
  `)}
`;

const Text = styled.p`
  margin-bottom: 1rem;
`;

const Container = styled.div<ContainerProps>`
  ${({ asSecondary }) =>
    asSecondary
      ? css`
          display: flex;

          ${mediaMinWidth.sm(css`
            flex-direction: column;
          `)}
        `
      : null}
`;

const ContactWrapper = styled.div`
  display: flex;
  align-items: center;

  &::after {
    content: '·';

    margin: 0 1rem;
  }

  ${mediaMinWidth.sm(css`
    margin: 1.2rem 0;
  `)}
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;

  margin-right: 0.5rem;
`;

const LinkWrapper = styled.div`
  display: flex;

  margin-top: 1rem;

  ${mediaMinWidth.lg(css`
    justify-content: center;

    margin: 2rem 0;
  `)}
`;

const Link = styled.a`
  color: ${pickColor('title')};
`;

const Separator = styled.div`
  margin: 1rem;

  &::before {
    content: '/';
  }
`;

export {
  Footer,
  Wrapper,
  IconWrapper,
  Text,
  Container,
  LinkWrapper,
  Link,
  Separator,
  ContactWrapper,
};
